export const Types = {
    GET_EKEDEQUIPMENTS: "GET_EKEDEQUIPMENTS",
    SET_EKEDEQUIPMENTS: "SET_EKEDEQUIPMENTS",

    ADD_EKEDEQUIPMENT: "ADD_EKEDEQUIPMENT",
    UPDATE_EKEDEQUIPMENT: "UPDATE_EKEDEQUIPMENT",
    DELETE_EKEDEQUIPMENT: "DELETE_EKEDEQUIPMENT",

    IS_UPDATED_TASK: "IS_UPDATED_TASK",
    RESET_IS_UPDATED_TASK: "RESET_IS_UPDATED_TASK",

    GET_EKED_EQUIPMENT_FILES: "GET_EKED_EQUIPMENT_FILES",
    SET_EKED_EQUIPMENT_FILES: "SET_EKED_EQUIPMENT_FILES",
    ADD_EKED_EQUIPMENT_FILES: "ADD_EKED_EQUIPMENT_FILES",
    DELETE_EKED_EQUIPMENT_FILES: "DELETE_EKED_EQUIPMENT_FILES",

    GET_EKED_EQUIPMENT_FILE_PREVIEWS: "GET_EKED_EQUIPMENT_FILE_PREVIEWS",
    SET_EKED_EQUIPMENT_FILE_PREVIEWS: "SET_EKED_EQUIPMENT_FILE_PREVIEWS",
};

export const getEkedEquipments = (payload) => ({
    type: Types.GET_EKEDEQUIPMENTS,
    payload: payload,
});

export const setEkedEquipments = (payload) => ({
    type: Types.SET_EKEDEQUIPMENTS,
    payload: payload,
});

export const addEkedEquipment = (payload) => ({
    type: Types.ADD_EKEDEQUIPMENT,
    payload: payload,
});

export const updateEkedEquipment = (payload) => ({
    type: Types.UPDATE_EKEDEQUIPMENT,
    payload: payload,
});

export const deleteEkedEquipment = (payload) => ({
    type: Types.DELETE_EKEDEQUIPMENT,
    payload: payload,
});

export const isUpdateTask = (payload) => ({
    type: Types.IS_UPDATED_TASK,
    payload,
});

export const resetIsUpdateTask = (payload) => ({
    type: Types.RESET_IS_UPDATED_TASK,
    payload,
});

export const getEkedEquipmentFiles = (payload) => ({
    type: Types.GET_EKED_EQUIPMENT_FILES,
    payload: payload,
});

export const setEkedEquipmentFiles = (payload) => ({
    type: Types.SET_EKED_EQUIPMENT_FILES,
    payload: payload,
});

export const addEkedEquipmentFiles = (payload) => ({
    type: Types.ADD_EKED_EQUIPMENT_FILES,
    payload: payload,
});

export const deleteEkedEquipmentFiles = (payload) => ({
    type: Types.DELETE_EKED_EQUIPMENT_FILES,
    payload: payload,
});

export const getEkedEquipmentFilePreviews = (payload) => ({
    type: Types.GET_EKED_EQUIPMENT_FILE_PREVIEWS,
    payload: payload,
});

export const setEkedEquipmentFilePreviews = (payload) => ({
    type: Types.SET_EKED_EQUIPMENT_FILE_PREVIEWS,
    payload: payload,
});

